import DropDown from '../../../components/DropDown';
import DateRangeToggle from './DateRangeToggle'
import FlexWrapper from '../../FlexWrapper';
import AnalyticsExportButton from './AnalyticsExportButton';

const AnalyticsToggleHeader = ({ value, values, setValue, dateRanges, selectedDateRange, setSelectedDateRange, minMenuWidth, oneWordToggle, maxMenuWidth, placement, justifyContent, mb, mt, exportData, exportHeaders, exportFilename, exportLoading }) => {
	const others = values ? values.filter(v => v !== value) : [];

	const displayTimeFrame = (time) => {
		if (!time || typeof time === "string") return "All Time"
		let string = `${time.months ? time.months === 1 ? "1 Month" : time.months + " Months" : ""} ${time.days ? time.days === 1 ? "1 Day" : time.days + " Days" : ""} ${time.years ? time.years === 1 ? "1 Year" : time.years + " Years" : ""}`
		return string
	}

	const renderWord = (option) => {
		const word = oneWordToggle.find(w => {
			return option.includes(w)
		})
		return word ? word : option;
	}

	const hasExport = exportHeaders && exportFilename;

	return (
		<FlexWrapper className={`analytics-header ${mb ? "mb-" + mb : "mb-l"}${mt ? " mt-" + mt : ""}`} fullWidth justify="space-between">
			<DropDown
				fixed
				value={<p className="font-weight-semi-bold">{value}</p>}
				transparent
				clickable
				minMenuWidth={minMenuWidth}
				maxMenuWidth={maxMenuWidth}
				placement={placement}
				justifyContent={justifyContent}
			>
				{others.map(o => <li key={o} onClick={() => setValue(o)}>{oneWordToggle ? renderWord(o) : o}</li>)}
			</DropDown>
			<FlexWrapper gap="s">
				{dateRanges && <DateRangeToggle value={displayTimeFrame(selectedDateRange)} onChange={setSelectedDateRange} dateRanges={dateRanges} />}
				{hasExport && (
					<AnalyticsExportButton
						headers={exportHeaders}
						data={exportData}
						filename={exportFilename}
						loading={exportLoading}
					/>
				)}
			</FlexWrapper>
		</FlexWrapper >

	);
}

export default AnalyticsToggleHeader;
